import { defineStore } from "pinia";

import type { DashboardFilters } from "@/types/request/dashboardFilters";

export const useDashboardStore = defineStore("dashboard", {
  state: () => ({
    filters: {
      initial_datetime: undefined,
      final_datetime: undefined,
    } as DashboardFilters,
  }),
  actions: {
    setFilters(newFilters: DashboardFilters) {
      this.filters = newFilters;
    },
  },
});
